import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SmFormService } from "../../sm-form-service";
import { SmFormFieldVM, SmFormState, SmFormTypes } from "../../sm-form.model";

@Component({
    standalone: false,
    selector: 'sm-form-previous-value',
    templateUrl: './sm-form-previous-value.component.html',
    styleUrls: ['./sm-form-previous-value.component.scss']
})
export class SmFormPreviousValueComponent {

    constructor(private service: SmFormService) { }

    @Input() model: SmFormFieldVM;
    @Input() formState: SmFormState;

    @Output() revertToPreviousValue: EventEmitter<any> = new EventEmitter();

    public getPreviousValue() {
        const previousValue = this.service.formatFieldValue(this.model.PreviousValue, this.model.FieldType, this.model.Options, this.formState);

        if (this.model.FieldType == SmFormTypes.Select || this.model.FieldType == SmFormTypes.MultiSelect) {
            return this.preserveSpaces(previousValue);
        }

        return previousValue;
    }

    private preserveSpaces(value: string): string {
        return value?.replace(/ {2,}/g, (match) => ' ' + '\u00A0'.repeat(match.length - 1));
    }

    public fieldHasPreviousValue() {
        return this.service.fieldHasPreviousValue(this.model, this.formState);
    }
}